import { render, staticRenderFns } from "./CheckoutTimer.vue?vue&type=template&id=148efabe&"
import script from "./CheckoutTimer.vue?vue&type=script&lang=js&"
export * from "./CheckoutTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports